<template>

    <kt-modal :visible="recordVisible" :title="recordTitle" @dismiss="onDismiss()" size="modal-lg">
        <template #body>
            <expense-form v-model="record"></expense-form>
        </template>

        <template #footer>
            <div class="row w-100">
                <div :class="{ 'col-4': record.Id, 'col-6': !record.Id }">
                    <button @click="onDismiss()" class="btn btn-sm btn-outline-secondary form-control">Close</button>
                </div>
                <div class="col-4" v-if="record.Id">
                    <button @click="deleteRecord()" class="btn btn-sm btn-outline-danger form-control">Delete</button>
                </div>
                <div :class="{ 'col-4': record.Id, 'col-6': !record.Id }">
                    <button @click="saveRecord()" class="btn btn-sm btn-outline-primary form-control">Save</button>
                </div>
            </div>
        </template>
    </kt-modal>

</template>

<script lang="ts" setup>

import { ref, onUnmounted, watch } from "vue";
import { useRoute, useRouter } from "vue-router";

// import Api from "@/services/Api.js";

import ApiService from "@/services/ApiService";
import Emitter from "@/services/Emitter";

import Helper from "@/services/Helper";
import Alert from "@/services/Alert";
import ExpenseForm from "@/components/Expenses/ExpenseForm.vue";
import KtModal from "@/components/UI/KtModal.vue";

import { ExpenseModel } from "@/models/ExpenseModel";

const route = useRoute();
const recordTitle = ref("Expense Entry");
const recordVisible = ref(true);

const props = defineProps({
    requestId: {
        type: Number,
        default: 0
    },
    clientId: {
        type: Number,
        default: 0
    },
    techId: {
        type: Number,
        default: 0
    },
    embedded: {
        type: Boolean,
        default: false
    }
});

const emit = defineEmits(["cancel", "saved"]);

const newRecord = (): ExpenseModel => {
    const expense = new ExpenseModel();
    // Pre-populate with context if provided
    if (props.requestId) {
        expense.RequestId = props.requestId;
    }
    if (props.clientId) {
        expense.CustomerNumber = props.clientId;
    }
    if (props.techId) {
        expense.AssignedTo = props.techId;
    }
    // Set default expense date to today
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    expense.ExpenseDate = `${year}-${month}-${day}`;
    return expense;
};

const record = ref<ExpenseModel>(newRecord());

const saveRecord = async () => 
{
    // prep the record ...
    let data = Helper.prep(record.value);
    
    // TODO - validate record here
    console.debug("save", data);
    
    // save ...
    data = await ApiService.saveExpense(data);

    // reload any stores you need to ...
    // ...

    if (props.embedded) {
        emit("saved");
    } else {
        // redirect ...
        Emitter.emit("redirect", "/expense/edit/" + data.Id);
    }
};

const deleteRecord = async () => 
{
    Alert.notify("Deletion has been disabled");
};


const onDismiss = () => 
{
    if (props.embedded) {
        emit("cancel");
    } else {
        Emitter.emit("redirect", "/expense/list");
    }
};

const unwatch:Array <Function> = [];

const loadRecord = async (val:string) =>
{
    if (props.embedded && props.requestId) {
        // In embedded mode, create a new expense for the request
        let newRec = newRecord();
        newRec.RequestId = props.requestId;
        record.value = newRec;
    } else {
        switch (val) {
            case "new":
                record.value = newRecord();
                break;

            default:
                // let rec = await Api.loadExpense(route.params.id);
                let rec = await ApiService.loadExpense(val);
                console.debug("expense", rec);
                record.value = rec;
                break;
        }
    }
};

if (!props.embedded) {
    unwatch.push(watch(() => route.params.id, async (nv, ov) => 
    {
        // Handle both new and edit routes
        if (!nv && route.name === "Expense New") {
            loadRecord("new");
        } else if (nv) {
            loadRecord(nv + "");
        }
    }, 
    { 
        immediate: true 
    }));
} else {
    // Load immediately in embedded mode
    loadRecord("new");
}

onUnmounted(() => 
{
    unwatch.forEach((un) => 
    {
        un();
    });
});

</script>